var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPresidenteBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 179,
    viewBox: "0 0 306 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13_1236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.5 0.884033H28.5C15.2452 0.884033 4.5 11.6292 4.5 24.884V146.884C4.5 160.139 15.2452 170.884 28.5 170.884H277.5C290.755 170.884 301.5 160.139 301.5 146.884V24.884C301.5 11.6292 290.755 0.884033 277.5 0.884033Z",
    fill: "#003A5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0651 100.168C89.0651 95.5312 85.314 91.7654 80.6569 91.6952H80.5862C80.572 91.6952 80.5578 91.6952 80.5295 91.6952C80.5012 91.6952 80.5012 91.6952 80.4729 91.6952H69.9274V116.145H72.6168V108.655V105.986V94.379H80.3738H80.6145C83.7852 94.4212 86.3756 97.0347 86.3756 100.182C86.3756 103.33 83.7852 105.929 80.6145 105.986H80.2606H76.3255L84.5637 116.145H88.3007L82.0583 108.501C86.05 107.784 89.0792 104.341 89.0792 100.168H89.0651Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.097 89.756H53.012C52.9979 89.756 52.9696 89.756 52.9554 89.756C52.9413 89.756 52.9129 89.756 52.8988 89.756H41.2491V118.07H44.5473V92.6084H53.0545C56.4376 92.6646 59.1836 95.4328 59.1836 98.777C59.1836 102.121 56.4376 104.889 53.0545 104.946H52.6723H46.5148L48.8221 107.784H53.097C58.0512 107.7 62.043 103.695 62.043 98.763C62.043 93.8309 58.0512 89.8262 53.097 89.756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.6 92.7911H139.924V115.006H142.6V92.7911Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.039 91.681H225.959V94.4492H232.612V116.131H235.4V94.4492H242.039V91.681Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.741 115.021L111.331 112.449H99.1435V104.608H105.726L108.542 101.826H99.1435V95.3766H108.769L111.359 92.7911H96.5531V101.826V104.608V115.021H108.741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.838 92.7911V108.416L203.311 95.5452L200.65 92.7911H200.636V96.6131V115.021H203.311V99.3672L215.838 112.238V112.252L218.513 115.006V114.992V111.17V92.7911H215.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.119 95.3625C164.427 95.3625 167.739 98.6365 167.739 103.92C167.739 109.203 164.356 112.463 159.104 112.463H154.348V95.3766C155.424 95.3766 156.967 95.3766 159.133 95.3766M159.133 92.8052C152.452 92.8052 151.758 92.8192 151.758 92.8192V115.035H159.119C165.63 115.035 170.344 110.749 170.344 103.92C170.344 97.0909 165.814 92.7911 159.133 92.7911V92.8052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.495 92.4399C120.872 92.4399 118.14 94.7302 118.14 97.7794C118.14 102.107 122.556 103.765 124.453 104.468C127.992 105.789 129.124 106.786 129.124 108.557C129.124 111.213 127.241 112.786 124.099 112.786C121.183 112.786 119.046 110.875 118.777 110.622L116.951 112.435C117.375 112.843 120.135 115.358 124.113 115.358C128.968 115.358 131.728 112.351 131.728 108.557C131.728 104.763 128.515 103.231 125.373 102.051C122.23 100.871 120.744 99.6482 120.744 97.7653C120.744 96.0511 122.499 94.9972 124.509 94.9972C126.01 94.9972 127.383 95.8262 128.685 97.0909L130.525 95.2642C128.558 93.3532 126.59 92.4117 124.524 92.4117L124.495 92.4399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.118 115.021L192.709 112.449H180.535V104.608H187.117L189.92 101.826H180.535V95.3766H190.161L192.751 92.7911H177.945V101.826V104.608V115.021H190.118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.324 118.07L268.339 115.049H252.896V104.805H261.502L264.871 101.489H252.896V92.8333H265.622L268.679 89.756H249.81V101.25V104.805V118.07H265.324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.214 129.044C114.558 129.044 115.62 129.409 116.399 130.154C117.177 130.899 117.573 131.854 117.573 133.034C117.573 134.215 117.191 135.184 116.441 135.887C115.691 136.589 114.601 136.941 113.185 136.941H110.666V139.273C110.666 139.948 110.326 140.285 109.632 140.285H108.486V129.044H113.185H113.214ZM113.341 135.03C113.964 135.03 114.473 134.833 114.841 134.454C115.21 134.074 115.408 133.596 115.408 133.02C115.408 132.444 115.21 131.924 114.827 131.531C114.431 131.137 113.921 130.941 113.27 130.941H110.68V135.03H113.341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.063 138.388H136.032C136.711 138.388 137.051 138.725 137.051 139.4V140.299H128.897V129.058H130.044C130.723 129.058 131.063 129.395 131.077 130.069V138.388H131.063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.89 139.554C149.649 140.046 149.253 140.285 148.686 140.285H147.172L152.961 129.044H153.174L158.963 140.285H157.448C156.882 140.285 156.472 140.046 156.245 139.554L155.736 138.514H150.399L149.904 139.554H149.89ZM153.06 133.259L151.432 136.66H154.66L153.046 133.259H153.06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.389 129.044V129.311L173.033 138.388H178.157C178.837 138.388 179.176 138.725 179.176 139.4V140.299H169.268V140.046L175.638 130.955H170.768C170.089 130.955 169.749 130.617 169.735 129.943V129.044H179.375H179.389Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.341 139.554C192.1 140.046 191.704 140.285 191.137 140.285H189.623L195.412 129.044H195.625L201.414 140.285H199.899C199.333 140.285 198.923 140.046 198.696 139.554L198.187 138.514H192.85L192.355 139.554H192.341ZM195.511 133.259L193.884 136.66H197.111L195.497 133.259H195.511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.767 61.2034C178.186 45.8312 173.981 33.5361 173.981 33.5361C173.387 33.5361 172.92 34.042 172.92 34.042C172.722 34.8008 169.933 45.3253 162.318 57.8451C159.416 62.6367 156.995 66.262 154.957 69.0582C152.919 66.2479 150.498 62.6226 147.596 57.8451C139.981 45.3253 137.192 34.8008 136.994 34.042C136.994 34.042 136.527 33.5361 135.933 33.5361C135.933 33.5361 131.728 45.8171 142.147 61.2034C145.501 66.1496 149.083 69.8591 152.282 72.557C149.819 75.6062 148.035 77.2502 146.606 78.5429C146.606 78.5429 147.002 78.7116 147.724 78.7116C148.078 78.7116 150.994 77.5593 154.943 74.6788C158.892 77.5593 161.808 78.7116 162.162 78.7116C162.898 78.7116 163.28 78.5429 163.28 78.5429C161.851 77.2643 160.081 75.6062 157.604 72.557C160.803 69.8591 164.384 66.1496 167.739 61.2034H167.767Z",
    fill: "url(#paint0_linear_13_1236)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M173.996 33.55C173.401 33.55 172.934 34.0559 172.934 34.0559C172.736 34.8147 169.947 45.3392 162.332 57.8591C159.43 62.6506 157.01 66.2759 154.971 69.0721C152.933 66.2618 150.512 62.6366 147.611 57.8591C139.995 45.3392 137.207 34.8147 137.008 34.0559C137.008 34.0559 136.541 33.55 135.947 33.55C135.947 33.55 135.593 45.831 145.997 61.2174C148.757 65.2923 151.291 68.5241 153.499 71.0393C150.385 75.1002 148.262 77.0814 146.606 78.5569C146.606 78.5569 147.002 78.7255 147.724 78.7255C148.163 78.7255 150.852 77.0393 154.943 72.6552C159.034 77.0393 161.737 78.7255 162.162 78.7255C162.898 78.7255 163.28 78.5569 163.28 78.5569C161.638 77.0674 159.515 75.1002 156.387 71.0393C158.595 68.5241 161.143 65.2923 163.889 61.2174C174.307 45.8451 173.939 33.55 173.939 33.55H173.996Z",
    fill: "url(#paint1_linear_13_1236)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13_1236",
    x: 0.5,
    y: 0.884033,
    width: 305,
    height: 178,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_1236"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_1236",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_1236",
    x1: 154.971,
    y1: 78.7116,
    x2: 154.971,
    y2: 33.5502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93D500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B189"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13_1236",
    x1: 154.971,
    y1: 78.7114,
    x2: 154.971,
    y2: 33.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresidenteBlue);
export default __webpack_public_path__ + "static/media/presidenteBlue.0719c1c8f42c7df57f24759ec438c6d8.svg";
export { ForwardRef as ReactComponent };